export default "skymp5-front/2fa9115f92c78b1ee996613adcef500a.gif";